
import { Component, Vue } from 'vue-property-decorator';
import { viagemStore } from '../../../utils/store-accessor';
import { IDeparture } from '@/interfaces/departure';
import { format } from 'date-fns';
@Component
export default class Show extends Vue {
  public headers = [
    {
      text: 'Nome',
      sortable: true,
      value: 'full_name',
      align: 'left',
      filterable: true,
    },
    {
      text: 'Departamento',
      sortable: true,
      value: 'departure',
      align: 'left',
      filterable: true,
    },
    {
      text: 'Cargo',
      sortable: true,
      value: 'role',
      align: 'left',
      filterable: true,
    },
  ];
  public search = '';
  public row = 'unidade';
  public loading = false;
  public dialog = false;
  public departureId = '';
  public dataInicial = '';
  public dataFinal = '';
  public disponiveis = [];
  public ocupados = [];
  public dataViagemInicial = format(new Date(), 'yyyy-MM-dd');
  public dataViagemFinal = format(new Date(), 'yyyy-MM-dd');
  public showCalendarDataViagemFinal = false;
  public showCalendarDataViagemInicial = false;
  public minData = ['2021', '1', '1'];
  public maxData = ['2021', '1', '1'];
  public chartCategoriesPessoa = [];
  public chartCategoriesUnidade = [];
  public counter = 0;
  public chartOptions = {};
  get viagens() {
    return viagemStore.viagens;
  }
  get viagemGantt() {
    return this.viagens.map((value) => {
      //@ts-ignore
      const indexIgual = this.chartCategoriesPessoa.indexOf(value.user);
      //@ts-ignore
      const inicio = value.data_inicio.split('T')[0].split('-');
      //@ts-ignore
      const fim = value.data_fim.split('T')[0].split('-');
      return {
        //@ts-ignore
        name: value.nome_fantasia,
        start: Date.UTC(inicio[0], inicio[1] - 1, inicio[2]),
        end: Date.UTC(fim[0], fim[1] - 1, fim[2]),
        y: indexIgual,
      };
    });
  }
  get viagemGanttInvertido() {
    return this.viagens.map((value) => {
      //@ts-ignore
      const indexIgual = this.chartCategoriesUnidade.indexOf(value.nome_fantasia);
      //@ts-ignore
      const inicio = value.data_inicio.split('T')[0].split('-');
      //@ts-ignore
      const fim = value.data_fim.split('T')[0].split('-');
      return {
        //@ts-ignore
        name: value.user,
        start: Date.UTC(inicio[0], inicio[1] - 1, inicio[2]),
        end: Date.UTC(fim[0], fim[1] - 1, fim[2]),
        y: indexIgual,
      };
    });
  }
  public selectedDepartureBuscar: IDeparture = {
    id: 0,
    name: 'Todos',
    description: '',
  };
  public async buscar() {
    const users = await viagemStore.getViagensUsersAndTravelStatus({
      departureid: this.selectedDepartureBuscar.id,
      dataInicial: this.dataViagemInicial,
      dataFinal: this.dataViagemFinal,
    });
    this.ocupados = [];
    this.disponiveis = [];
    for (let i = 0; i < users.length; i++) {
      if (users[i].ocupado === false) {
        //@ts-ignore
        this.disponiveis.push(users[i]);
      } else {
        //@ts-ignore
        this.ocupados.push(users[i]);
      }
    }
  }

  public mudarGrafico() {
    //@ts-ignore
    let menor = this.viagens[0].data_inicio;
    //@ts-ignore
    let maior = this.viagens[0].data_fim;
    for (let i = 0; i < this.viagens.length; i++) {
      //@ts-ignore
      const indexIgual = this.chartCategoriesPessoa.indexOf(this.viagens[i].user);
      //@ts-ignore
      const indexIgualInvertido = this.chartCategoriesUnidade.indexOf(this.viagens[i].nome_fantasia);
      if (indexIgual < 0) {
        //@ts-ignore
        this.chartCategoriesPessoa.push(this.viagens[i].user);
      }
      if (indexIgualInvertido < 0) {
        //@ts-ignore
        this.chartCategoriesUnidade.push(this.viagens[i].nome_fantasia);
      }
      //@ts-ignore
      if (new Date(this.viagens[i].data_inicio) < new Date(menor)) {
        //@ts-ignore
        menor = this.viagens[i].data_inicio;
      }
      //@ts-ignore
      if (new Date(this.viagens[i].data_fim) > new Date(maior)) {
        //@ts-ignore
        maior = this.viagens[i].data_fim;
      }
    }
    this.minData = menor.split('T')[0].split('-');
    this.maxData = maior.split('T')[0].split('-');
    if (this.row == 'unidade') {
      this.chartOptions = {
        plotOptions: {
          series: {
            animation: false, // Do not animate dependency connectors
            dragDrop: {
              draggableX: true,
              draggableY: true,
              dragMinY: 0,
              dragMaxY: 2,
              // dragPrecisionX: day / 3 // Snap to eight hours
            },
            dataLabels: {
              enabled: true,
              format: '{point.name}',
              style: {
                cursor: 'default',
                pointerEvents: 'none',
              },
            },
            allowPointSelect: true,
          },
        },
        yAxis: {
          type: 'category',
          categories: this.chartCategoriesUnidade,
          min: 0,
          max: this.chartCategoriesUnidade.length - 1,
        },
        xAxis: {
          //@ts-ignore
          min: Date.UTC(this.minData[0], this.minData[1] - 1, this.minData[2]),
          //@ts-ignore
          max: Date.UTC(this.maxData[0], this.maxData[1] - 1, this.maxData[2]),
        },
        rangeSelector: {
          enabled: true,
          selected: 0,
        },
        navigator: {
          enabled: true,
          liveRedraw: true,
          series: {
            type: 'gantt',
            pointPlacement: 0.5,
            pointPadding: 0.25,
          },
          yAxis: {
            min: 0,
            max: 6,
            reversed: true,
            categories: [],
          },
        },
        series: [
          {
            name: 'Viagem',
            data: this.viagemGanttInvertido,
          },
        ],
      };
    } else if (this.row == 'colaborador') {
      this.chartOptions = {
        plotOptions: {
          series: {
            animation: false, // Do not animate dependency connectors
            dragDrop: {
              draggableX: true,
              draggableY: true,
              dragMinY: 0,
              dragMaxY: 2,
              // dragPrecisionX: day / 3 // Snap to eight hours
            },
            dataLabels: {
              enabled: true,
              format: '{point.name}',
              style: {
                cursor: 'default',
                pointerEvents: 'none',
              },
            },
            allowPointSelect: true,
          },
        },
        yAxis: {
          type: 'category',
          categories: this.chartCategoriesPessoa,
          min: 0,
          max: this.chartCategoriesPessoa.length - 1,
        },
        xAxis: {
          //@ts-ignore
          min: Date.UTC(this.minData[0], this.minData[1] - 1, this.minData[2]),
          //@ts-ignore
          max: Date.UTC(this.maxData[0], this.maxData[1] - 1, this.maxData[2]),
        },
        rangeSelector: {
          enabled: true,
          selected: 0,
        },
        navigator: {
          enabled: true,
          liveRedraw: true,
          series: {
            type: 'gantt',
            pointPlacement: 0.5,
            pointPadding: 0.25,
          },
          yAxis: {
            min: 0,
            max: 6,
            reversed: true,
            categories: [],
          },
        },
        series: [
          {
            name: 'Viagem',
            data: this.viagemGantt,
          },
        ],
      };
    }
  }
  public async show() {
    this.mudarGrafico();
    this.dialog = true;
  }
}
